var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"mt-4"},_vm._l((_vm.items),function(item){return (item.hidden === false)?_c(_vm.resolveNavItemComponent(item),{key:item.header || item.title,tag:"component",attrs:{"item":item}}):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }